import { render } from "./GdprBanner.vue?vue&type=template&id=765fe1f3"
import script from "./GdprBanner.vue?vue&type=script&lang=js"
export * from "./GdprBanner.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\19480-florette\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__